var cardHeight = 300;
var cardMargin = 32;
var right_col_container = '.layout__right-col.sticky__parent';

// �������� ����������� ������ �������
function loadRightCol() {

    // ���� ��� ������ ������� ������������ �� ��������
    if ($(right_col_container).length) {
        var rightColContainer = $(right_col_container).last();

        // ������� ���������� ���-�������, ������� ����� ������ � ��������� �����
        var cubeLimit = parseInt(rightColContainer.height() / (cardHeight + cardMargin));

        // ���� ������ 3 � ������ ������, �� ��������� ����������
        if (cubeLimit > 2) {
            $.post('/s_ajax_macrogeo.php', {
                limit: cubeLimit
            }, function (data) {
                rightColContainer.append(data);
            });
        }

        return true;

    }

    return false;
}

function isEmpty(el) {
    return !$.trim(el.html());
}
